import { useRef } from "react";
import { Layers, Upload, LocateFixed, Crosshair, Plus, Minus, Maximize2, Ruler, PenTool, PenLine, StickyNote, BookOpen, WifiOff, FileText, SearchCheck as MapPinSearch } from "lucide-react";

const BTN = "relative w-9 h-9 rounded-xl grid place-items-center transition-colors";
export const toolBtnClass = (on) => `${BTN} ${on ? "text-white" : "text-slate-700 dark:text-slate-200 hover:bg-emerald-50 dark:hover:bg-slate-800"}`;

// Vertical icon toolbar (ported from the Bolt MapControls) — every map tool lives here.
export function MapToolbar({ actions, active = {}, counts = {}, slots = null }) {
  const fileRef = useRef(null);
  const groups = [
    [["layers", Layers, "Layers panel", counts.layers], ["village", MapPinSearch, "Find village & its files"], ["legend", BookOpen, "Toggle legend"]],
    [["measure", Ruler, "Measure distance"], ["area", PenTool, "Measure area"], ["draw", PenLine, "Draw property boundary", counts.drawings]],
    [["note", StickyNote, "Add field note", counts.notes], ...(counts.notes > 0 ? [["report", FileText, "Download field notes report (PDF)"]] : []), ["locate", LocateFixed, "Go to my location"], ["coords", Crosshair, "Jump to coordinates"]],
    [["upload", Upload, "Add KML / GeoJSON / Shapefile to map (temporary)"], ["offline", WifiOff, "Offline basemap"]],
    [["zoomIn", Plus, "Zoom in"], ["zoomOut", Minus, "Zoom out"], ["fullscreen", Maximize2, "Full screen"]],
  ];
  return (
    <div data-testid="map-toolbar" className="glass rounded-2xl p-1.5 shadow-2xl flex flex-col gap-1 max-h-[calc(100vh-7rem)] overflow-y-auto">
      {groups.map((items, gi) => (
        <div key={gi} className={`flex flex-col gap-1 ${gi > 0 ? "pt-1 mt-0.5 border-t border-black/5 dark:border-white/10" : ""}`}>
          {items.map(([key, Icon, title, count]) => (
            <button key={key} type="button" data-testid={`toolbar-${key}`} title={title} aria-label={title}
              onClick={() => (key === "upload" ? fileRef.current?.click() : actions[key]?.())}
              className={toolBtnClass(active[key])} style={active[key] ? { background: "var(--terracotta)" } : {}}>
              <Icon size={17} />
              {count > 0 && <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-emerald-900 dark:bg-emerald-500 text-white dark:text-slate-950 text-[9px] font-mono font-bold grid place-items-center">{count}</span>}
            </button>
          ))}
          {gi === 3 && slots}
        </div>
      ))}
      <input ref={fileRef} type="file" accept=".kml,.kmz,.geojson,.json,.zip" className="hidden" data-testid="toolbar-upload-input" onChange={(e) => { const f = e.target.files?.[0]; if (f) actions.upload?.(f); e.target.value = ""; }} />
    </div>
  );
}
